import React, { useRef } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import Audio from "assets/pronounciation.png";
import EulerAudio from "assets/euler-audio.mp3";
import { SIZES } from "theme";
import { useTranslation } from "react-i18next";

const Pronounciation = ({ small, audio }) => {
  const { t } = useTranslation();

  const audioRef = useRef(null);

  const handleAudio = () => {
    audioRef.current.play();
  };

  return (
    <Box>
      <audio
        src={audio?.attributes?.audio?.data?.attributes?.url || EulerAudio}
        ref={audioRef}
      ></audio>
      <Box
        textAlign="center"
        display="flex"
        flexDirection="column"
        padding={small ? "0 20px" : "24px 80px"}
      >
        <Text
          textColor="white"
          fontWeight="bold"
          fontSize={small ? SIZES.twentyFour : "40px"}
          margin={small ? "20px 0" : "40px 0"}
        >
          {t("Pronunciation")}
        </Text>
        <Box cursor="pointer" onClick={handleAudio}>
          <img
            src={audio?.attributes?.media?.data?.attributes?.url}
            alt={audio?.attributes?.media?.data?.attributes?.alternativeText}
          />
        </Box>
        <Text
          textColor="white"
          fontWeight="bold"
          fontSize={small ? SIZES.twenty : "30px"}
          margin={small ? "20px 0" : "40px 0"}
        >
          OY - l er
        </Text>
        <Text
          textColor="white"
          fontWeight="bold"
          fontSize="40px"
          margin="40px 0"
        >
          <Text
            textColor="white"
            fontWeight="bold"
            fontSize={small ? SIZES.twentyFour : "40px"}
            margin="40px 0"
          >
            {t("Trusted by Investors")}
          </Text>
        </Text>
      </Box>
    </Box>
  );
};

export default Pronounciation;
